import React from "react";
import { useLocation } from "react-router-dom";
import { HTMLTemplate } from "@minerva-analytics/pantheon";
import { Helmet } from "react-helmet";

import { Background, LegalCard, LegalContainer } from "./Legal.styles";
import { LUCINA_DOMAIN } from "../../constants";
import { PRODUCT_NAME } from "../../text";

const commonInfo = {
  dba: "The Science Spotlight",
  domain: `https://www.${LUCINA_DOMAIN}`,
  email: `help@${LUCINA_DOMAIN}`,
  name: PRODUCT_NAME,
  address1: "1770 Massachusetts Ave #268",
  state: "Cambridge, MA 02140",
  country: "USA",
};

const legalInfo = {
  "/ccpa": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/CalPolicy.html`,
    variables: { ...commonInfo },
  },
  "/cookie": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/CookiePolicy.html`,
    variables: { ...commonInfo },
  },
  "/terms": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/Terms.html`,
    variables: { ...commonInfo },
  },
  "/privacy": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/Privacy.html`,
    variables: { ...commonInfo },
  },
};

const legalMeta = {
  "/ccpa": {
    title: "Privacy Policy for California Residents | The Science Spotlight",
    description:
      "Learn about our Privacy Policy for California Residents here.",
  },
  "/cookie": {
    title: "Cookie Policy | The Science Spotlight",
    description:
      "Want to understand how The Science Spotlight uses cookies? Read our Cookie Policy here.",
  },
  "/terms": {
    title: "Terms of Use | The Science Spotlight",
    description:
      "Read our Terms of Use and get started with The Science Spotlight today!",
  },
  "/privacy": {
    title: "Privacy Policy | The Science Spotlight",
    description:
      "Want to understand how we use your data? Read our Privacy Policy here.",
  },
};

const Legal = () => {
  const { pathname } = useLocation();

  return (
    <>
      <Helmet>
        <title>{legalMeta[pathname].title}</title>
        <meta
          name="og:title"
          property="og:title"
          content={legalMeta[pathname].title}
        />
        <meta
          name="og:description"
          property="og:description"
          content={legalMeta[pathname].description}
        />
        <meta
          name="description"
          property="description"
          content={legalMeta[pathname].description}
        />
      </Helmet>
      <LegalContainer>
        <LegalCard>
          <HTMLTemplate {...legalInfo[pathname]} />
        </LegalCard>
        <Background />
      </LegalContainer>
    </>
  );
};

export default Legal;
